import { render, staticRenderFns } from "./BelposhtaModule.vue?vue&type=template&id=1f727d55"
import script from "./BelposhtaModule.vue?vue&type=script&lang=js"
export * from "./BelposhtaModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports